import { headingElementType } from "./HeadingElement.js";
const headingOneToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading1",
  label: "Heading level 1",
  title: "Heading level 1",
  suchThat: { level: 1, isNumbered: false }
};
const headingOneNumberedToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading1Numbered",
  label: "Numbered heading level 1",
  title: "Numbered heading level 1",
  suchThat: { level: 1, isNumbered: true }
};
const headingTwoToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading2",
  label: "Heading level 2",
  title: "Heading level 2",
  suchThat: { level: 2, isNumbered: false }
};
const headingTwoNumberedToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading2Numbered",
  label: "Numbered heading level 2",
  title: "Numbered heading level 2",
  suchThat: { level: 2, isNumbered: true }
};
const headingThreeToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading3",
  label: "Heading level 3",
  title: "Heading level 3",
  suchThat: { level: 3, isNumbered: false }
};
const headingThreeNumberedToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading3Numbered",
  label: "Numbered heading level 3",
  title: "Numbered heading level 3",
  suchThat: { level: 3, isNumbered: true }
};
const headingFourToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading4",
  label: "Heading level 4",
  title: "Heading level 4",
  suchThat: { level: 4, isNumbered: false }
};
const headingFourNumberedToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading4Numbered",
  label: "Numbered heading level 4",
  title: "Numbered heading level 4",
  suchThat: { level: 4, isNumbered: true }
};
const headingFiveToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading5",
  label: "Heading level 5",
  title: "Heading level 5",
  suchThat: { level: 5, isNumbered: false }
};
const headingFiveNumberedToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading5Numbered",
  label: "Numbered heading level 5",
  title: "Numbered heading level 5",
  suchThat: { level: 5, isNumbered: true }
};
const headingSixToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading6",
  label: "Heading level 6",
  title: "Heading level 6",
  suchThat: { level: 6, isNumbered: false }
};
const headingSixNumberedToolbarButton = {
  elementType: headingElementType,
  contemberIcon: "heading6Numbered",
  label: "Numbered heading level 6",
  title: "Numbered heading level 6",
  suchThat: { level: 6, isNumbered: true }
};
export {
  headingFiveNumberedToolbarButton,
  headingFiveToolbarButton,
  headingFourNumberedToolbarButton,
  headingFourToolbarButton,
  headingOneNumberedToolbarButton,
  headingOneToolbarButton,
  headingSixNumberedToolbarButton,
  headingSixToolbarButton,
  headingThreeNumberedToolbarButton,
  headingThreeToolbarButton,
  headingTwoNumberedToolbarButton,
  headingTwoToolbarButton
};
//# sourceMappingURL=headingToolbarButtons.js.map
